import { useCallback, useState, Dispatch, SetStateAction } from 'react';

export const useToggle = (
	initialValue?: boolean,
): [boolean, () => void, Dispatch<SetStateAction<boolean>>] => {
	const [value, setValue] = useState<boolean>(!!initialValue);

	const toggleValue = useCallback(() => setValue(!value), [value]);

	return [value, toggleValue, setValue];
};
